var _palette$fontFamilies, _palette$shades$, _palette$shades$2, _palette$fontFamilies2;
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useMeterDetailsStyles = makeStyles({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '16px 16px 12px 16px'
  },
  subtitle: {
    marginTop: '2px',
    color: palette.shades[700]
  },
  tableWrapper: {
    overflowX: 'auto',
    '& .MuiDataGrid-root': {
      border: 'none',
      borderRadius: 0,
      fontSize: '13px',
      fontFamily: (_palette$fontFamilies = palette.fontFamilies) === null || _palette$fontFamilies === void 0 ? void 0 : _palette$fontFamilies.poppins
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: (_palette$shades$ = palette.shades[50]) !== null && _palette$shades$ !== void 0 ? _palette$shades$ : palette.shades[100],
      borderBottom: "1px solid ".concat(palette.shades[300]),
      borderTop: "1px solid ".concat(palette.shades[300]),
      minHeight: '60px !important',
      maxHeight: '60px !important'
    },
    '& .MuiDataGrid-columnHeader': {
      padding: '0 8px',
      borderRight: '1px solid #e1e7ed'
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      whiteSpace: 'normal',
      lineHeight: '1.3',
      fontWeight: 600,
      fontSize: '12px',
      overflow: 'visible',
      textOverflow: 'clip'
    },
    '& .MuiDataGrid-cell': {
      borderBottom: '1px solid #e1e7ed',
      borderRight: '1px solid #e1e7ed',
      padding: '0 8px',
      fontSize: '13px',
      fontWeight: '400 !important'
    },
    '& .MuiDataGrid-cell *': {
      fontWeight: '400 !important'
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: (_palette$shades$2 = palette.shades[50]) !== null && _palette$shades$2 !== void 0 ? _palette$shades$2 : '#fafafa'
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto'
    },
    '& .MuiDataGrid-footerContainer': {
      display: 'none'
    }
  },
  ownerAbsorption: {
    padding: '8px 16px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[100]
  },
  ownerAbsorptionText: {
    fontWeight: 600,
    fontSize: '13px',
    color: palette.shades[800]
  },
  emptyState: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '64px 16px'
  },
  emptyStateIcon: {
    width: 180,
    marginBottom: 16
  },
  emptyStateText: {},
  usageWarning: {
    margin: '12px 16px 0 16px'
  },
  usageWarningContent: {
    color: palette.warning.dark,
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    padding: '6px 10px',
    borderRadius: '2px',
    backgroundColor: palette.warning.light,
    fontFamily: (_palette$fontFamilies2 = palette.fontFamilies) === null || _palette$fontFamilies2 === void 0 ? void 0 : _palette$fontFamilies2.poppins,
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginRight: '4px'
    }
  },
  saveButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  submitterWrapper: {
    minHeight: '540px'
  }
});
export default useMeterDetailsStyles;